export const GLOBALS = {
    buttonLoadTime: 500,     // ms
    workHoursInWeek: 38
}